import { TriangleAlert } from 'lucide-react';

/**
 * The only piece of chrome above the list, and only when something is
 * genuinely wrong. It names what broke and points at the row that owns the
 * fix — it deliberately carries no actions of its own, so there's exactly one
 * place to act.
 */
export interface AttentionItem {
  /** Row anchor id to scroll to. */
  anchorId: string;
  name: string;
  reason: string;
}

export function IntegrationsAttentionBanner({ items }: { items: AttentionItem[] }) {
  if (items.length === 0) return null;

  return (
    <div
      data-testid="integrations-attention-banner"
      aria-label="Integrations that need attention"
      role="region"
      className="flex items-start gap-3 rounded-xl border border-amber-300/70 bg-amber-50 px-4 py-3 text-sm text-amber-950 dark:border-amber-800/50 dark:bg-amber-950/25 dark:text-amber-100"
    >
      <TriangleAlert className="mt-0.5 size-4 shrink-0" aria-hidden />
      <ul className="min-w-0 flex-1 space-y-1">
        {items.map((item) => (
          <li key={item.anchorId} className="leading-5">
            <a
              href={`#${item.anchorId}`}
              className="font-medium underline-offset-4 hover:underline"
            >
              {item.name}
            </a>
            <span className="text-amber-900/80 dark:text-amber-100/80"> — {item.reason}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}
